import { render, staticRenderFns } from "./Cobranca.vue?vue&type=template&id=4638dd3a&scoped=true"
import script from "./Cobranca.vue?vue&type=script&lang=js"
export * from "./Cobranca.vue?vue&type=script&lang=js"
import style0 from "./Cobranca.vue?vue&type=style&index=0&id=4638dd3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4638dd3a",
  null
  
)

export default component.exports